import { Price } from '@shared/models/price.model';

export class MobilePhoneProductPrice {
  monthlyPrice: Price;
  totalPrice: Price;
  agreementLength: number;
}
